import React, {Component, ReactNode} from 'react';
import PokerMenuButtonBalance from 'app/components/poker/poker_menu_container/PokerMenuButtonBalance';
import PokerMenuButtonDeposit from 'app/components/poker/poker_menu_container/PokerMenuButtonDeposit';
import PokerMenuButtonPause from 'app/components/poker/poker_menu_container/PokerMenuButtonPause';
import PokerMenuButtonQuit from 'app/components/poker/poker_menu_container/PokerMenuButtonQuit';
import PokerMenuButtonSound from 'app/components/poker/poker_menu_container/PokerMenuButtonSound';
import PlayerInterface from 'app/interfaces/poker/PlayerInterface';
import {isDesktop} from 'app/utils';

interface Props {
    closeTable: () => void
    sitOut: () => void
    sitIn: () => void
    player: PlayerInterface
    isEnabledSound: boolean
    enableSound: () => void
    tableId: string
    playmoney: boolean
}

export default class PokerMenuContainer extends Component<Props> {
    render(): ReactNode {
        const {player, tableId, playmoney} = this.props;

        return <div className="poker-menu-container">
            {isDesktop() && <div className="poker-menu-container__item">
                <PokerMenuButtonBalance playmoney={playmoney}/>
                <PokerMenuButtonDeposit tableId={tableId} playmoney={playmoney}/>
            </div>}
            <div className="poker-menu-container__item">
                <PokerMenuButtonPause
                    sitOut={this.props.sitOut}
                    sitIn={this.props.sitIn}
                    player={this.props.player}
                />
            </div>
            <div className="poker-menu-container__item">
                <PokerMenuButtonQuit onClick={this.props.closeTable} disabled={!player || (player?.waiting_drop_out ?? false)}/>
            </div>
            <div className="poker-menu-container__item">
                <PokerMenuButtonSound enabled={this.props.isEnabledSound} onClick={this.props.enableSound}/>
            </div>
        </div>;
    }
}
